<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Столовые</h2>
          <v-dialog
            v-model="dialogNewCafe"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-3" color="secondary" v-on="on" :disabled="!isadmin">
                <v-icon>
                  add
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Новая столовая
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewCafeClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>

                <v-text-field
                v-model="ititle"
                label="Название"
                ></v-text-field>

                <v-select
                :items="orgs"
                v-model="iorgid"
                label="Организация"
                item-text="title" item-value="orgid" clearable
                ></v-select>

                <v-text-field
                v-model="icafeid"
                type="number"
                label="Идентификатор кафе"
                ></v-text-field>

                <v-text-field
                v-model="iposkey"
                label="Ключ"
                append-icon="casino"
                @click:append="generateNuid()"
                ></v-text-field>

                <v-autocomplete
                flat
                label="Локация"
                :items="locations"
                v-model="ilocationid"
                item-text="name" item-value="locationid" clearable
                ></v-autocomplete>

                <v-autocomplete
                flat
                label="Обслуживаемые школы"
                :items="schools"
                v-model="ischools"
                multiple
                item-text="name" item-value="schoolid" clearable
                ></v-autocomplete>

                <v-text-field
                  v-model="ipaddr"
                  label="ip адрес VPN"
                  type="ip"
                  :rules="ipRules"
                  required
                />
              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="!icafeid || !iorgid || !iposkey || !ischools || !ilocationid || !ititle || !matchIP"
                  @click="addCafe()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewCafeClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-select
            v-if="selected && selected.length > 0 && isadmin"
            :items="[
            { text: 'Переключить продажи за наличку', value: 'cashpayment' },
            { text: 'Переключить продажи по карте', value: 'cardpayment' },
            { text: 'Переключить продажи по банковской карте', value: 'bankpayment' }]"
            v-model="massAction"
            label="Контроль источников оплат"
            width="200px"
          ></v-select>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="selected && selected.length > 0 && massAction && isadmin"
                v-bind="attrs"
                v-on="on"
                small
                icon
                outlined
                class="mx-3"
                color="green"
                @click="applyMassAction()">
              <v-icon>play_arrow</v-icon>
            </v-btn>
            </template>
            <span>Выполнить</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>

        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          v-model="selected"
          :headers="headers"
          :items="cafes"
          :items-per-page="-1"
          :search="search"
          item-key="cafeid"
          sort-by="iponline"
          hide-default-footer
          dense
          :show-select="isadmin"
        >
          <template v-slot:item.online="{ item }">
            <v-icon small color="#D50000" v-if="item.online === false">close</v-icon>
          </template>
          <template v-slot:item.ipaddr="{ item }">
            <span
              v-if="item.hasOwnProperty('online')"
              :style="`color: ${item.iponline ? '#2E7D32' : '#D50000' }`"
            >{{ item.ipaddr }}</span>
            <span v-else>{{ item.ipaddr }} ?</span>
          </template>
          <template v-slot:item.locationid="{ item }">
            {{ (locations.find(x => x.locationid === item.locationid) || { name: item.locationid }).name }}
          </template>
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
          <template v-slot:item.cashpayment="{ item }">
            <v-icon v-if="item.cashpayment === false" small color="#D50000">close</v-icon>
            <v-icon v-else small color="#2E7D32">check_small</v-icon>
          </template>
          <template v-slot:item.cardpayment="{ item }">
            <v-icon v-if="item.cardpayment === false" small color="#D50000">close</v-icon>
            <v-icon v-else small color="#2E7D32">check_small</v-icon>
          </template>
          <template v-slot:item.bankpayment="{ item }">
            <v-icon v-if="item.bankpayment === false" small color="#D50000">close</v-icon>
            <v-icon v-else small color="#2E7D32">check_small</v-icon>
          </template>
          <template v-slot:item.action="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">more_vert</v-icon>
              </template>
              <v-list>
                <v-list-item
                  @click=";deleteItem(item)"
                >
                  <v-list-item-title>Удалить столовую: <b>{{ item.title }} @ {{ item.cafeid }}</b></v-list-item-title>
                  <v-list-item-action><v-icon>delete</v-icon></v-list-item-action>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const moment = require('moment')
const nanoid = require('nanoid/generate')
const NANOID_ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz'
const NANOID_LENGTH = 12
export default {
  name: 'Cafes',
  data: () => ({
    dialogNewCafe: false,
    cafes: [],
    orgs: [],
    locations: [],
    schools: [],
    search: '',
    icafeid: null,
    iorgid: null,
    ititle: 'Столовая ',
    iposkey: null,
    ilocationid: null,
    ischools: null,
    ipaddr: '',
    ipRules: [
      v => !!v || 'ip is required',
      v => /^(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])){3}$/
        .test(v) || 'ip must be valid'
    ],
    selected: [],
    massAction: null
  }),
  methods: {
    generateNuid () {
      this.iposkey = nanoid(NANOID_ALPHABET, 4) + '-' + nanoid(NANOID_ALPHABET, 4) + '-' + nanoid(NANOID_ALPHABET, 4)
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    async fetch () {
      try {
        await Promise.all([
          this.fetchCafes(),
          this.fetchLocations(),
        ])
        await Promise.all([
          this.fetchOnline(),
          this.fetchOrgs(),
          this.fetchSchools(),
          this.fetchEkartaposInfo(),
        ])
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchCafes () {
      if (this.isadmin) {
        const { cafes, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-cafes-with-secrets'
        })
        this.cafes = cafes.filter(x => x.locationid).map(c => {
          c.schools = c.schools.join(', ')
          return c
        })
      } else {
        const { cafes, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-cafes'
        })
        this.cafes = cafes.filter(x => x.locationid)
      }
    },
    async fetchOnline () {
      const data = (await Promise.all([
        this.$store.dispatch('sioRequest', { topic: 'cafes-online' }),
        this.$store.dispatch('sioRequest', { topic: 'cafes-ip-online' }),
      ])).map(x => x.online)
      const online = data[0].reduce((r, x) => {
        r[x] = x
        return r
      }, {})
      const iponline = data[1].reduce((r, x) => {
        r[x] = x
        return r
      }, {})
      this.cafes = this.cafes.map(x => {
        x.online = !!online[x.cafeid]
        x.iponline = !!iponline[x.cafeid]
        return x
      })
    },
    async fetchOrgs () {
      const { orgs, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-orgs'
      })
      this.orgs = orgs.filter(x => x.activities && x.activities.find(y => y.activitytypeid === 'cafe'))
    },
    async fetchSchools () {
      const { schools, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-schools'
      })
      this.schools = schools
    },
    async fetchLocations () {
      const { locations, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-locations'
      })
      this.locations = locations
    },
    async fetchEkartaposInfo () {
      const { info } = await this.$store.dispatch('sioRequest', { topic: 'fetch-ekartapos-info' })
      this.cafes = this.cafes.map(cafe => {
        if (cafe.online) {
          cafe.version = info.find(i => i.cafeid === cafe.cafeid).version || null
          cafe.branch = info.find(i => i.cafeid === cafe.cafeid).branch || null
        } else {
          cafe.version = null
          cafe.branch = null
        }
        return cafe
      })
    },
    dialogNewCafeClose () {
      this.dialogNewCafe = false
      this.icafeid = 'Столовая '
      this.iorgid = null
      this.ititle = null
      this.iposkey = null
      this.ilocationid = null
      this.ischools = null
    },
    async addCafe () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-cafe',
          pl: {
            cafeid: this.icafeid,
            orgid: this.iorgid,
            title: this.ititle,
            poskey: this.iposkey,
            locationid: this.ilocationid,
            schools: this.ischools,
            ipaddr: this.ipaddr
          }
        })
        this.$store.dispatch('snack', meta)
        this.dialogNewCafeClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    },
    async deleteItem (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить ${item.title} @ ${item.cafeid} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-cafe',
          pl: {
            cafeid: item.cafeid
          }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    },
    async applyMassAction () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'toggle-cafe-payments',
          pl: {
            paymenttype: this.massAction,
            ids: this.selected.map(x => x.cafeid)
          }
        })
        this.selected = []
        this.massAction = null
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    matchIP () {
      return /^(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])){3}$/
        .test(this.ipaddr)
    },
    headers () {
      if (this.isadmin) {
        return [
          { text: 'ipaddr', value: 'ipaddr', width: 125, align: 'right' },
          { text: 'link', value: 'online', width: 70, align: 'left' },
          { text: 'title', value: 'title', width: 210 },
          { text: 'orgid', value: 'orgid' },
          { text: 'cafeid', value: 'cafeid' },
          { text: 'schools', value: 'schools' },
          { text: 'poskey', value: 'poskey' },
          { text: 'cts', value: 'cts' },
          { text: 'location', value: 'locationid' },
          { text: 'cashpayment', value: 'cashpayment', sortable: true },
          { text: 'cardpayment', value: 'cardpayment', sortable: true },
          { text: 'bankpayment', value: 'bankpayment', sortable: true },
          { text: 'действия', value: 'action', sortable: false }
        ]
      } else {
        return [
          { text: 'ipaddr', value: 'ipaddr', width: 125, align: 'right' },
          { text: 'link', value: 'online', width: 70, align: 'left' },
          { text: 'title', value: 'title', width: 210 },
          { text: 'orgid', value: 'orgid' },
          { text: 'cafeid', value: 'cafeid' },
          { text: 'schools', value: 'schools' },
          { text: 'cts', value: 'cts' },
          { text: 'location', value: 'locationid' },
          { text: 'cashpayment', value: 'cashpayment', sortable: true },
          { text: 'cardpayment', value: 'cardpayment', sortable: true },
          { text: 'bankpayment', value: 'bankpayment', sortable: true },
          { text: 'действия', value: 'action', sortable: false }
        ]
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
